import { Component, OnInit, OnChanges, ViewChild, Input, Output, EventEmitter, ElementRef , SimpleChanges} from "@angular/core";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";

import { CountryStateDropdownService } from "./country-state-dropdown.service";
import { FormControl,Validators } from "@angular/forms";
import { DropdownModel } from "../../../shared/models/dropdown.model";
import { FuseAlertService } from '@fuse/components/alert';


@Component({
  selector: "state-dropdown",
  templateUrl: "./state-dropdown.component.html"
})
export class StateDropdownComponent implements OnInit, OnChanges {

  stateAutoCompleteList: DropdownModel[];
  stateList: DropdownModel[];

  @ViewChild('stateAutoComplete', { read: ElementRef }) stateAutoComplete: ElementRef;
  @ViewChild(MatAutocompleteTrigger) stateTrigger;

  selectedStateFormControl: FormControl;

  @Input() isRequired: boolean;

  @Input() countryId:number= 0;

  @Input() value: any;

  @Output() valueChange = new EventEmitter();

  isValueBindOnInit: boolean = false;

  constructor(private _countryStateDropdownService: CountryStateDropdownService,public fuseAlertService: FuseAlertService,) {

  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
  */
  ngOnInit(): void {
    if (this.isRequired) {
      this.selectedStateFormControl = new FormControl('', [Validators.required]);
    } else {
      this.selectedStateFormControl = new FormControl();
    }
    this.getStateByCountry();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['countryId'] && !changes['countryId'].isFirstChange()) {
      this.getStateByCountry();
    }
    if (changes['value'] && !changes['value'].isFirstChange()) {
      this.isValueBindOnInit = false;
    }
  }

  bindFormControlValue() {
    if (this.value && !this.isValueBindOnInit) {
      this.isValueBindOnInit = true;
      const objSelectedCountry = this.stateList.find(x => x.text === this.value)
      if (objSelectedCountry) {
        this.selectedStateFormControl.setValue(objSelectedCountry.text);
      }
    }
  }

  getStateByCountry() {
    if (this.countryId > 0) {
      this._countryStateDropdownService.getStateByCountry(this.countryId).subscribe(res => {
        if (res.status === 1) {
          //this.fuseAlertService.show(res.message, res.status);
          this.stateList = res.data;
          this.stateAutoCompleteList = res.data;
          this.selectedStateFormControl.setValue(null);
          this.selectedStateFormControl.setErrors(null);
          this.bindFormControlValue();
        }
      });
    } else {
      this.stateList = [];
      this.stateAutoCompleteList = [];
      this.selectedStateFormControl.setValue(null);
      this.selectedStateFormControl.setErrors(null);
    }
  }

  onInputChangedState(searchStr: string): void {
    this.stateAutoCompleteList = [];
    this.stateAutoCompleteList = this.stateList.filter(option =>
      option.text.toString().toLowerCase().includes(searchStr.toLowerCase()));
  }

  displayFnAutoCompleteState(state) {
    if (state != null && state.value != null && state.value !== 0) {
      return state.text;
    } else return state;
  }

  onChangeState(event) {
    if (event.isUserInput === true) {
      if (event.source.selected) {
        this.valueChange.emit(event.source.value);
      }
    }
  }
   
  ngAfterViewInit() {
    if (!this.stateTrigger) return;
    this.stateTrigger.panelClosingActions
      .subscribe(e => {
        if (!(e && e.source)) {
          var currentValue = this.selectedStateFormControl.value;
          if (currentValue) {
            const objCurrentValue = this.stateList.find(x => x.text === currentValue);
            if (objCurrentValue) {
              this.valueChange.emit(currentValue);
              this.stateAutoCompleteList = this.stateList;
              this.stateTrigger.closePanel();
            } else {
              this.valueChange.emit(null);
              this.selectedStateFormControl.setValue(null);
              this.stateAutoCompleteList = this.stateList;
              this.stateTrigger.closePanel();
            }
          } else {
            this.valueChange.emit(null);
            this.selectedStateFormControl.setValue(null);
            this.stateAutoCompleteList = this.stateList;
            this.stateTrigger.closePanel();
          }
        }
      });
  }
  
}
